import request from '@/request'

// 获取律师列表信息
export const getLawyerlist = data => {
  return request({
    url: '/mobile_Lawyer_Vipwd/list.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 获取律师详情
export const getLawyerDetail = data => {
  return request({
    url: '/mobile_Lawyer_Vipwd/view.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 获取咨询类型
export const getAdviceType = data => {
  return request({
    url: '/mobile_SysDd/FTU_LAWYER_ADVICETYPE.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 获取咨询状态
export const getAdviceStatue = data => {
  return request({
    url: '/mobile_SysDd/FTU_LAWYER_STATUSID.action',
    method: 'post',
    data,
    isMd5: false
  })
}
// 提交咨询
export const postAsklaw = data => {
  return request({
    url: '/mobile_Lawyer_Vipwd/ask.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 获取我的咨询
export const getLawMyask = data => {
  return request({
    url: '/mobile_Lawyer_Vipwd/adviceList.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 获取咨询详情
export const getLawaskDetail = data => {
  return request({
    url: '/mobile_Lawyer_Vipwd/adviceView.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 回复咨询
export const answerLawyer = data => {
  return request({
    url: '/mobile_Lawyer_Vipwd/answer.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
